import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import L from 'leaflet'
import { MapUpdater } from './MapUpdater'
import { MapClickHandler } from './MapClickHandler'

interface IMapComponentProps {
  center: [number, number]
  zoom: number
  markerPosition: [number, number]
  onMapClick: (e: L.LeafletMouseEvent) => void
  className?: string
  icon?: L.Icon
}

export const MapComponent = ({
  center,
  zoom,
  markerPosition,
  onMapClick,
  className,
  icon
}: IMapComponentProps) => {
  return (
    <MapContainer
      center={center}
      zoom={zoom}
      className={className}
      attributionControl={false}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={markerPosition} icon={icon} />
      <MapClickHandler onMapClick={onMapClick} />
      <MapUpdater lat={markerPosition[0]} lng={markerPosition[1]} />
    </MapContainer>
  )
}
